import { QuoteRequest } from "../types";
import { round } from "../utils";

const computeSalesAdministrationCost = ({
  salesAdministrationTime,
  salesAdministrationHourlyRate,
}: {
  salesAdministrationTime: number | null;
  salesAdministrationHourlyRate: number | null;
}) => {
  return round(((salesAdministrationTime || 0) * (salesAdministrationHourlyRate || 0)) / 60);
};

const computeSalesAdministrationMargin = ({
  salesAdministrationCost,
  salesAdministrationMarginRatio,
}: {
  salesAdministrationCost: number;
  salesAdministrationMarginRatio: number | null;
}) => {
  return round((salesAdministrationCost * (salesAdministrationMarginRatio || 0)) / 100);
};

export const computeSalesAdministrationPrice = ({
  salesAdministrationTime,
  salesAdministrationHourlyRate,
  salesAdministrationMarginRatio,
}: Pick<
  QuoteRequest,
  "salesAdministrationTime" | "salesAdministrationHourlyRate" | "salesAdministrationMarginRatio"
>) => {
  const salesAdministrationCost = computeSalesAdministrationCost({
    salesAdministrationTime,
    salesAdministrationHourlyRate,
  });

  const salesAdministrationMargin = computeSalesAdministrationMargin({
    salesAdministrationCost,
    salesAdministrationMarginRatio,
  });

  const salesAdministrationPrice = salesAdministrationCost + salesAdministrationMargin;

  return {
    salesAdministrationPrice,
    salesAdministrationCost,
    salesAdministrationMargin,
  };
};
